import { render, staticRenderFns } from "./DialogueCenter.vue?vue&type=template&id=64a3a318&scoped=true"
import script from "./DialogueCenter.vue?vue&type=script&lang=js"
export * from "./DialogueCenter.vue?vue&type=script&lang=js"
import style0 from "./DialogueCenter.vue?vue&type=style&index=0&id=64a3a318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a3a318",
  null
  
)

export default component.exports